/* eslint-disable @typescript-eslint/only-throw-error -- TanStack Router requires throwing redirect() */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { Home } from "../../pages/Home";
import { tokenStorage } from "../../utils/tokenStorage";
import { attemptSilentRefresh } from "../../utils/tokenRefresh";

export const Route = createFileRoute("/_public/")({
  beforeLoad: async () => {
    if (!tokenStorage.getAccessToken()) return;

    if (tokenStorage.isAccessTokenValid()) {
      throw redirect({ to: "/app" });
    }

    // Token cookie exists but JWT is expired — try silent refresh
    const refreshed = await attemptSilentRefresh();
    if (refreshed) {
      throw redirect({ to: "/app" });
    }

    // Refresh failed (expired or missing refresh token) — clear stale cookies
    tokenStorage.clearAuthCookies();
  },
  component: Home,
});
